module.exports = __webpack_public_path__ + "static/img/egg_g_17.c4d6514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_17.png
// module id = xhPu
// module chunks = 1